import { useUserContext } from 'context/UserContext';
import MapDetails from '../MapDetails';
import { useIsMobile } from 'hooks';
import MapsTabsView from './MapsTabsView';

export type AssignedMaps = {
    onZoneClick: (region: string, zone: string) => void;
};
export const AssignedMaps = ({ onZoneClick }: AssignedMaps) => {
    const { user } = useUserContext();
    const isMobile = useIsMobile();

    const hasMultipleCancerMaps = new Set(user?.assignedRegions?.map(({ mapName }) => mapName)).size > 1;

    if (isMobile && hasMultipleCancerMaps) {
        return <MapsTabsView onZoneClick={onZoneClick} />;
    }

    return (
        <>
            {user?.assignedRegions?.map(assignedRegion => (
                <MapDetails key={assignedRegion.id} userId={user!.id} regionId={assignedRegion.id} onZoneClick={onZoneClick} />
            ))}
        </>
    );
};
